export default __webpack_public_path__ + "static/media/wi-night-snow.22325caf.svg";